import { LanguajeEnum } from '@core/enums';
import { createAction, props } from '@ngrx/store';

export const REDIRECT_TO = createAction('[Core] Redirect To', props<{ path: string }>());

export const CORE_UPDATE_SLUG = createAction('[Core] Update Slug', props<{ slug: string | null, accountSlug: string | null }>());

export const CORE_CHANGE_LANGUAJE = createAction('[Core] Change Languaje', props<{ languaje: LanguajeEnum }>());

export const CORE_UPDATE_LOADING = createAction('[Core] Update Loading', props<{ loading: boolean }>());


